import { isSupportedCountry, parsePhoneNumber, type CountryCode, type PhoneNumber } from 'libphonenumber-js';

export type ParsedPhone = {
  flag: string;
  national: string;
  international: string;
  e164: string;
  country: string;
  raw: string;
};

export const toFlagEmoji = (countryCode: string) =>
  countryCode
    .toUpperCase()
    .replace(/./g, (c) => String.fromCodePoint(c.charCodeAt(0) - 65 + 0x1f1e6));

export function parsePhone(
  input: string,
  defaultRegion?: CountryCode,
): ParsedPhone | null {
  if (!input) return null;
  // Normalize 00-prefixed international numbers to E.164
  const normalized = input.replace(/^00/, '+');
  try {
    const p: PhoneNumber = parsePhoneNumber(normalized, defaultRegion);
    if (!p.isValid()) return null;
    return {
      flag: toFlagEmoji(p.country),
      national: p.formatNational(),
      international: p.formatInternational(),
      e164: p.number as string,
      country: p.country,
      raw: input,
    };
  } catch {
    return null;
  }
}

// Partner locales are usually bare languages ("sl"); maximize() fills in the likely region ("SI").
export function countryFromLocale(locale?: string | null, fallback: CountryCode = 'DE'): CountryCode {
  try {
    const region = new Intl.Locale((locale || '').replace('_', '-')).maximize().region as CountryCode | undefined;
    return region && isSupportedCountry(region) ? region : fallback;
  } catch {
    return fallback;
  }
}
